import { useNavigate } from "react-router-dom";

const Dashboard: React.FC = () => {
  const navigate = useNavigate();

  const userData = localStorage.getItem("user");
  const user = userData ? JSON.parse(userData) : null;
  const currentRole = user.current_role;
  
  return (
    <section>
      <div className="container">
        <h4 className="dashboard__heading">
          {(currentRole == "1" || currentRole == "8") ? "Admin" : null} Dashboard
        </h4><br/>
        <div className="dashboard-mainBox">
          <div
            className="dashboard__modules scale--md cursor-pointer"
            onClick={() => {
              /*if (currentRole == "1" || currentRole == "8" || currentRole == "7") {
                navigate("/admin/competitions");
              } else {
                navigate("/competitions");
              }*/
              navigate("/competitions");
            }}
          >
            Competitions
          </div>
          {(currentRole == "1" || currentRole == "8") ? (
            <>
              {/* <div
                className="dashboard__modules scale--md cursor-pointer"
                onClick={() => navigate("/admin/performances-upload")}
              >
                Upload Performances CSV
              </div> */}
              <div
                className="dashboard__modules scale--md cursor-pointer"
                onClick={() => navigate("/admin/users")}
              >
                Users
              </div>
            </>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default Dashboard;
